import React from 'react';
import {
  Drawer, List, ListItem, ListItemIcon, ListItemText, IconButton,
  Divider, Toolbar, Box,
} from '@mui/material';
import {
  Dashboard,
  DirectionsCar,
  People,
  ReceiptLong,
  Logout,
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
  AttachMoney as AttachMoneyIcon,
  History as HistoryIcon,
  Inventory2 as Inventory2Icon,
  RequestQuote as RequestQuoteIcon,
  Event as EventIcon,
} from '@mui/icons-material';
import ConstructionIcon from '@mui/icons-material/Construction';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from './assets/logo_anduze.png';
import { useAuth } from '../AuthContext';
import Tooltip from '@mui/material/Tooltip';




// Paleta sugerida
export const PRIMARY_GRADIENT = 'linear-gradient(160deg, #223265 0%, #3a54d4 100%)';
const ACTIVE_COLOR = '#41aaff';
const LOGOUT_COLOR = '#ff4d4f';
const SIDEBAR_SHADOW = '4px 0 20px 0 rgba(32,40,120,0.10)';

const Sidebar = ({ collapsed, setCollapsed, isMobile = false, mobileOpen = false, onMobileClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  // En mobile el drawer es temporal/overlay: no tiene sentido el modo "icon-only".
  const effectiveCollapsed = isMobile ? false : collapsed;

  const handleToggle = () => {
    if (isMobile) {
      onMobileClose();
    } else {
      setCollapsed(!collapsed);
    }
  };

  const handleNavClick = () => {
    if (isMobile) onMobileClose();
  };


  const navItems = [
    { text: 'Clientes', icon: <People />, path: '/clientes' },
    { text: 'Vehículos', icon: <DirectionsCar />, path: '/vehiculos' },
    { text: 'Órdenes', icon: <Dashboard />, path: '/ordenes' },
    { text: 'Facturas', icon: <ReceiptLong />, path: '/facturas' },
    { text: 'Inventario', icon: <Inventory2Icon />, path: '/inventario' },
    { text: 'Ingresos y Gastos', icon: <AttachMoneyIcon />, path: '/ingresos-gastos' },
    { text: 'Presupuestos', icon: <RequestQuoteIcon />, path: '/presupuestos' },
    { text: 'Citas', icon: <EventIcon />, path: '/citas' },
    { text: 'Técnicos', icon: <ConstructionIcon />, path: '/tecnicos' },
    { text: 'Log Auditoría', icon: <HistoryIcon />, path: '/historial' },
  ];

  const drawerWidth = effectiveCollapsed ? 70 : 240;

  return (
    <Drawer
      variant={isMobile ? 'temporary' : 'permanent'}
      open={isMobile ? mobileOpen : true}
      onClose={isMobile ? onMobileClose : undefined}
      ModalProps={isMobile ? { keepMounted: true } : undefined}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          background: PRIMARY_GRADIENT,
          color: 'white',
          boxShadow: SIDEBAR_SHADOW,
          borderTopRightRadius: isMobile ? 0 : 24,
          borderBottomRightRadius: isMobile ? 0 : 24,
          transition: 'all 0.3s cubic-bezier(.4,0,.2,1)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: effectiveCollapsed ? 'center' : 'flex-start',
        }
      }}
    >
      {/* Logo y toggle */}
      <Toolbar sx={{
        width: '100%', justifyContent: effectiveCollapsed ? 'center' : 'space-between', px: 2, minHeight: 80
      }}>
        {!effectiveCollapsed && (
          <img
            src={logo}
            alt="ANDUZE"
            style={{ maxWidth: '110px', marginRight: 'auto', marginLeft: 2, filter: 'drop-shadow(0 2px 6px #1113)' }}
          />
        )}
        <IconButton onClick={handleToggle} sx={{ color: 'white' }}>
          {effectiveCollapsed ? <MenuIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </Toolbar>

      <Divider sx={{ backgroundColor: '#ffffff22', width: '100%', mb: 1 }} />

      {/* Listado de módulos */}
      <List sx={{ width: '100%' }}>
        {navItems.map(({ text, icon, path }, idx) => {
          const isActive = location.pathname.startsWith(path);

          return (

                <Tooltip
                    title={effectiveCollapsed ? text : ''}
                    placement="right"
                    arrow
                    key={text}
                    disableHoverListener={!effectiveCollapsed}
                  >
            <ListItem
              button
              key={text}
              component={Link}
              to={path}
              onClick={handleNavClick}
              sx={{
                color: isActive ? ACTIVE_COLOR : 'white',
                px: 2,
                py: 1.2,
                my: 0.2,
                borderLeft: isActive ? `4px solid ${ACTIVE_COLOR}` : '4px solid transparent',
                background: isActive ? '#ffffff14' : 'none',
                transition: 'all 0.18s',
                '&:hover': {
                  background: '#ffffff1a',
                  color: ACTIVE_COLOR,
                  '& .MuiListItemIcon-root': {
                    color: ACTIVE_COLOR,
                  }
                }
              }}
            >
              <ListItemIcon sx={{
                color: isActive ? ACTIVE_COLOR : 'white',
                minWidth: 36,
                fontSize: effectiveCollapsed ? 22 : 26,
                transition: 'color 0.18s'
              }}>
                {icon}
              </ListItemIcon>
              {!effectiveCollapsed && (
                <ListItemText
                  primary={text}

                />
              )}
            </ListItem>
             </Tooltip>
          )
        })}
       
        {/* --- Separador antes de logout --- */}
        <Divider sx={{ backgroundColor: '#050505ff', my: 1 }} />
         <Box sx={{ flexGrow: 1 }} />
        {/* Logout destacado */}
        <ListItem
          button
          onClick={() => {
            logout();
            navigate('/login');
            handleNavClick();
          }}
          sx={{
            px: 2,
            py: 1.3,
            mt: 0.4,
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 600,
            fontSize: '1.02rem',
            color: 'white',
            '&:hover': {
              backgroundColor: '#fff2f2',
              color: "#ff4d4f", 
              '& .MuiListItemIcon-root': {
                color: "#ff4d4f",
              }
            }
          }}
        >
          <ListItemIcon sx={{ color: LOGOUT_COLOR }}>
            <Logout />
          </ListItemIcon>
          {!effectiveCollapsed && (
            <ListItemText
              primary="Cerrar sesión"

            />
          )}
        </ListItem>
      </List>
    </Drawer>
  );
};

export default Sidebar;
